<template>
  <el-dialog
    :title="$t('OrganizationText')"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <div>
      <BjCompanyTree
        :flag="true"
        :default-checked-keys="form.companyLists"
        class="mt16"
        @check="onChangeCompany"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { userApi } from '@/api';
import BjCompanyTree from '@/components/BjCompanyTree';
export default {
  components: { BjCompanyTree },
  props: {},
  data() {
    return {
      id: null,
      form: {
        memberRoleList: [],
        companyLists: [],
      },
      dialogVisible: false,
      userInfo: {},
      userAllRoles: {},
    };
  },
  methods: {
    getUserInfoById(id) {
      userApi
        .getUserInfoById({
          userId: id,
        })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.userInfo = res;
          }
        });
    },
    getUserAllRolesById(id) {
      userApi
        .getUserAllRolesById({
          userId: id,
        })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.form.memberRoleList = res.map(e => {
              return {
                _innerMap: {},
                roleId: e.id,
                startDateActive: e.startDateActive,
                endDateActive: e.endDateActive,
              };
            });
          }
        });
    },
    getUserAllCompany(id) {
      userApi
        .getUserCompany({
          userId: id,
        })
        .then(res => {
          this.form.companyLists = res.companyLists;
        });
    },
    show(id) {
      this.form.companyLists = [];
      this.getUserInfoById(id);
      this.getUserAllRolesById(id);
      this.getUserAllCompany(id);
      this.dialogVisible = true;
    },
    hide() {
      this.handleClose();
    },
    onChangeCompany(data, node) {
      // 获取选中组织架构ids
      this.form.companyLists = node.checkedKeys;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    confirm() {
      this.form['id'] = this.userInfo.id;
      this.form['_token'] = this.userInfo._token;
      this.form['objectVersionNumber'] = Number(this.userInfo.objectVersionNumber);
      userApi
        .updateUserInfo({
          ...this.form,
          ...this.userInfo,
        })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            this.handleClose();
            this.reFresh();
          }
        });
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>

<style></style>
